import { createFileRoute } from '@tanstack/react-router';
import { useState, useCallback } from 'react';
import { MainContents } from '@/components/MainContents';
import { Button } from '@/components/Button';
import usePostJobPostImportText from '@/features/agent/provided_job_posts/api/usePostJobPostImportText';
import { useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/provided_job_posts/new/text/')({
  component: ProvidedJobPostsNewText,
  staticData: { title: 'テキストから取り込み' },
});

function ProvidedJobPostsNewText() {
  const [text, setText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { mutateAsync: submitText } = usePostJobPostImportText();
  const navigate = useNavigate();

  const handleSubmit = useCallback(async () => {
    if (!text.trim()) {
      alert('テキストを入力してください。');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await submitText({ text: text.trim() });
      navigate({
        to: '/agent/provided_job_posts/new/text/$id',
        params: { id: response.encrypt_id },
      });
    } catch (error) {
      alert(error instanceof Error ? error.message : 'テキストの送信に失敗しました。');
      setIsSubmitting(false);
    }
  }, [text, submitText, navigate]);

  return (
    <MainContents>
      <div className="overflow-hidden rounded-sm bg-white p-6 shadow-[0px_0px_2px_0px_rgba(0,0,0,0.2)]">
        <div className="pb-4">
          <h1 className="text-xl leading-[1.4] font-bold text-main">テキストから取り込み</h1>
        </div>

        <div className="flex flex-col gap-3">
          <textarea
            className="h-[320px] w-full resize-y rounded border border-border bg-white p-3 text-sm leading-[1.7] text-main outline-hidden focus:border-primary"
            placeholder="求人情報のテキストをここに貼り付けてください..."
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={isSubmitting}
          />
          <div className="flex items-center justify-between">
            <Button
              color="primary"
              size="md"
              type="button"
              onClick={handleSubmit}
              disabled={isSubmitting || !text.trim()}
            >
              {isSubmitting ? '送信中...' : '取り込み開始'}
            </Button>
          </div>
        </div>
      </div>
    </MainContents>
  );
}
